var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainLayout',[_c('movement-shift-component',{staticStyle:{"width":"99%","height":"calc(100% - 100px)","display":"flex","flex-direction":"column"},attrs:{"events":_vm.events,"shiftInfoList":_vm.shiftInfoList,"loading":_vm.loading},on:{"changeMonth":_vm.changeMonth}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0bea11e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/router/views/MovementShift.vue
// module id = null
// module chunks = 